import { render, staticRenderFns } from "./fee-sheet-templates-form.vue?vue&type=template&id=68b4178a&scoped=true&"
import script from "./fee-sheet-templates-form.vue?vue&type=script&lang=ts&"
export * from "./fee-sheet-templates-form.vue?vue&type=script&lang=ts&"
import style0 from "./fee-sheet-templates-form.vue?vue&type=style&index=0&id=68b4178a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b4178a",
  null
  
)

export default component.exports